"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const ro = require("redux-observable");
const recipients_1 = require("./recipients");
const addressBook_1 = require("./addressBook");
const _printProviders = require("../../modules/printProviders/epics");
const newExternalUser_1 = require("./newExternalUser");
const _finishings = require("../../modules/finishings/epics");
const _deliveryMethods = require("../../modules/deliveryMethods/epics");
const list_1 = require("./list");
const wizard_1 = require("./wizard");
const deliveryMethods = _deliveryMethods.default('distribution');
const finishings = _finishings.default('distribution');
const printProviders = _printProviders.default('distribution');
exports.allEpics = ro.combineEpics(
// Recipients
recipients_1.fetchRecipients, 
// Addressbook
addressBook_1.fetchExternalUsers, 
// PrintProviders
printProviders.fetchPrintProviders, 
// New external user
newExternalUser_1.newExternalUserEpics, 
// Finishings
finishings.fetchFinishings, 
// Delivary methods
deliveryMethods.fetchDeliveryMethods, 
// List
list_1.fetchDistributionList, list_1.deleteDistributionList, 
// Wizard
wizard_1.changeStep, wizard_1.createNewDistribution, wizard_1.editDistribution);
//# sourceMappingURL=index.js.map